import baseApi, {provideTag} from 'store/slices/api/baseApi'
import {convertToUrlParams} from 'utils'

const usersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getUsers: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `users${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('User'),
        }),
        getUser: build.query({
            query: (id) => {
                return {
                    url: `users/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('User', result),
        }),
        deleteUser: build.mutation({
            query: (id) => {
                return {
                    url: `users/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['User'],
        }),
        createUser: build.mutation({
            query: (data) => {
                return {
                    url: `users`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['User'],
        }),
        editUser: build.mutation({
            query: (data) => {
                return {
                    url: `users/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['User'],
        }),
        getUserAccounts: build.query({
            query: () => {
                return {
                    url: `users/userAccounts`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('UserAccounts', result),
        }),
        updateProfile: build.mutation({
            query: (data) => {
                return {
                    url: `users/profile/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['User'],
        }),
    }),
    overrideExisting: false,
})

export default usersApi

export const {
    useGetUsersQuery,
    useGetUserQuery,
    useDeleteUserMutation,
    useCreateUserMutation,
    useEditUserMutation,
    useGetUserAccountsQuery,
    useUpdateProfileMutation,
} = usersApi
